import { render } from "./AddPet.vue?vue&type=template&id=a4463f20&scoped=true"
import script from "./AddPet.vue?vue&type=script&lang=js"
export * from "./AddPet.vue?vue&type=script&lang=js"

import "./AddPet.vue?vue&type=style&index=0&id=a4463f20&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4463f20"]])

export default __exports__